import fileDownload from 'js-file-download'
import _ from 'lodash'
import qs from 'qs'
import { push } from 'react-router-redux'
import { toast } from 'react-toastify'

import api from '../lib/api'

export const CREATE_CHECKLIST_SUCCESS = 'CREATE_CHECKLIST_SUCCESS'
export const CREATE_CHECKLIST_FAILURE = 'CREATE_CHECKLIST_FAILURE'
export const UPDATE_CHECKLIST_SUCCESS = 'UPDATE_CHECKLIST_SUCCESS'
export const UPDATE_CHECKLIST_FAILURE = 'UPDATE_CHECKLIST_FAILURE'
export const READ_CHECKLIST_SUCCESS = 'READ_CHECKLIST_SUCCESS'
export const READ_CHECKLIST_FAILURE = 'READ_CHECKLIST_FAILURE'
export const LIST_CHECKLISTS_SUCCESS = 'LIST_CHECKLISTS_SUCCESS'
export const LIST_CHECKLISTS_FAILURE = 'LIST_CHECKLISTS_FAILURE'
export const CLEAR_CHECKLIST_SUCCESS = 'CLEAR_CHECKLIST_SUCCESS'
export const CLEAR_CHECKLIST_PROJECT_SUCCESS = 'CLEAR_CHECKLIST_PROJECT_SUCCESS'
export const READ_CHECKLIST_PROJECT_SUCCESS = 'READ_CHECKLIST_PROJECT_SUCCESS'
export const READ_CHECKLIST_PROJECT_FAILURE = 'READ_CHECKLIST_PROJECT_FAILURE'
export const LIST_CHECKLIST_PROJECTS_SUCCESS = 'LIST_CHECKLIST_PROJECTS_SUCCESS'
export const LIST_CHECKLIST_PROJECTS_FAILURE = 'LIST_CHECKLIST_PROJECTS_FAILURE'
export const SET_CHECKLIST_PROJECT_SUCCESS = 'SET_CHECKLIST_PROJECT_SUCCESS'
export const SET_CHECKLIST_ERRORS_SUCCESS = 'SET_CHECKLIST_ERRORS_SUCCESS'
export const CLEAR_CHECKLIST_ERRORS_SUCCESS = 'CLEAR_CHECKLIST_ERRORS_SUCCESS'
export const SET_CHECKLIST_RESULTS_FIELD_SUCCESS = 'SET_CHECKLIST_RESULTS_FIELD_SUCCESS'
export const LIST_CHECKLIST_RESULTS_SUCCESS = 'LIST_CHECKLIST_RESULTS_SUCCESS'
export const LIST_CHECKLIST_RESULTS_FAILURE = 'LIST_CHECKLIST_RESULTS_FAILURE'
export const UPDATE_CHECKLIST_RESULTS_SUCCESS = 'UPDATE_CHECKLIST_RESULTS_SUCCESS'
export const UPDATE_CHECKLIST_RESULTS_FAILURE = 'UPDATE_CHECKLIST_RESULTS_FAILURE'
export const CLEAR_CHECKLIST_RESULTS_SUCCESS = 'CLEAR_CHECKLIST_RESULTS_SUCCESS'
export const SET_CHECKLIST_DAILY_CURRENT_FIELD_SUCCESS = 'SET_CHECKLIST_DAILY_CURRENT_FIELD_SUCCESS'
export const SET_CHECKLIST_DAILY_CURRENT_ERRORS_SUCCESS = 'SET_CHECKLIST_DAILY_CURRENT_ERRORS_SUCCESS'
export const CLEAR_CHECKLIST_DAILY_CURRENT_ERRORS_SUCCESS = 'CLEAR_CHECKLIST_DAILY_CURRENT_ERRORS_SUCCESS'

export const createChecklist = (checklist) => async dispatch => {
  try {
    await api.post('/api/checklists', checklist)
    await dispatch({ type: CREATE_CHECKLIST_SUCCESS })
    dispatch(push('/checklist'))
  } catch (err) {
    toast.error('Failed to create a checklist.')
    console.log(err.msg)
    dispatch({ type: CREATE_CHECKLIST_FAILURE, err })
  }
}

export const updateChecklist = (checklist) => async dispatch => {
  try {
    await api.put(`/api/checklists/${checklist.id}`, checklist)
    await dispatch({ type: UPDATE_CHECKLIST_SUCCESS })
    dispatch(push('/checklist'))
  } catch (err) {
    toast.error('Failed to update the checklist.')
    console.log(err.msg)
    dispatch({ type: UPDATE_CHECKLIST_FAILURE, err })
  }
}

export const readChecklist = (checklistId, withChecklistProject = false) => async dispatch => {
  try {
    dispatch({ type: CLEAR_CHECKLIST_SUCCESS })
    const { data } = await api.get(`/api/checklists/${checklistId}`)
    dispatch({ type: READ_CHECKLIST_SUCCESS, data: { current: data } })
    if (withChecklistProject) {
      dispatch(readChecklistProject(data.projectId))
    }
  } catch (err) {
    toast.error('Failed to retrieve the checklist.')
    console.log(err.msg)
    dispatch({ type: READ_CHECKLIST_FAILURE, err })
  }
}

export const listChecklists = (query) => async dispatch => {
  try {
    const defaultQuery = { limit: process.env.REACT_APP_PAGE_LIMIT, page: 1 }
    const { data } = await api.get(`/api/checklists?${qs.stringify(_.merge(defaultQuery, query))}`)
    dispatch({ type: LIST_CHECKLISTS_SUCCESS, data: { query, list: data } })
  } catch (err) {
    toast.error('Failed to retrieve the list of the checklists.')
    console.log(err.msg)
    dispatch({ type: LIST_CHECKLISTS_FAILURE, err })
  }
}

export const readChecklistProject = (projectId) => async dispatch => {
  try {
    dispatch({ type: CLEAR_CHECKLIST_PROJECT_SUCCESS })
    const { data } = await api.get(`/api/checklists/projects/${projectId}`)
    dispatch({ type: READ_CHECKLIST_PROJECT_SUCCESS, data: { project: data } })
  } catch (err) {
    toast.error('Failed to retrieve the project of checklist.')
    console.log(err.msg)
    dispatch({ type: READ_CHECKLIST_PROJECT_FAILURE, err })
  }
}

export const listChecklistProjects = () => async dispatch => {
  try {
    const { data } = await api.get('/api/checklists/projects')
    dispatch({ type: LIST_CHECKLIST_PROJECTS_SUCCESS, data })
  } catch (err) {
    toast.error('Failed to retrieve the list of the projects.')
    console.log(err.msg)
    dispatch({ type: LIST_CHECKLIST_PROJECTS_FAILURE, err })
  }
}

export const listChecklistResults = (checklistId, checkDate, csv = false) => async dispatch => {
  try {
    const response = await api.get(`/api/checklist-results/${checklistId}/by-date/${checkDate}${csv ? '?format=csv' : ''}`)
    if (csv) {
      fileDownload(response.data, `daily-results-${checklistId}-${checkDate}.csv`)
      return
    }
    dispatch({ type: LIST_CHECKLIST_RESULTS_SUCCESS, data: { checklistId, ...response.data } })
  } catch (err) {
    toast.error('Failed to retrieve the checklist daily results.')
    console.log(err.msg)
    dispatch({ type: LIST_CHECKLIST_RESULTS_FAILURE, err })
  }
}

export const updateChecklistResults = (list) => async dispatch => {
  try {
    await api.put('/api/checklist-results/by-date', { list })
    await dispatch({ type: UPDATE_CHECKLIST_RESULTS_SUCCESS })
    dispatch(push('/checklist'))
  } catch (err) {
    toast.error('Failed to update the checklist daily results.')
    console.log(err.msg)
    dispatch({ type: UPDATE_CHECKLIST_RESULTS_FAILURE, err })
  }
}

export const clearChecklistResults = () => dispatch => {
  dispatch({ type: CLEAR_CHECKLIST_RESULTS_SUCCESS })
}

export const setChecklistProject = (project) => dispatch => {
  dispatch({ type: SET_CHECKLIST_PROJECT_SUCCESS, data: { project } })
}

export const setChecklistErrors = (errors) => dispatch => {
  dispatch({ type: SET_CHECKLIST_ERRORS_SUCCESS, data: { errors } })
}

export const clearChecklistErrors = () => dispatch => {
  dispatch({ type: CLEAR_CHECKLIST_ERRORS_SUCCESS })
}

export const setChecklistResultsField = (field, value) => dispatch => {
  dispatch({ type: SET_CHECKLIST_RESULTS_FIELD_SUCCESS, data: { field, value } })
}

export const setChecklistDailyCurrentField = (field, value) => dispatch => {
  dispatch({ type: SET_CHECKLIST_DAILY_CURRENT_FIELD_SUCCESS, data: { field, value } })
}

export const setChecklistDailyCurrentErrors = (errors) => dispatch => {
  dispatch({ type: SET_CHECKLIST_DAILY_CURRENT_ERRORS_SUCCESS, data: { errors } })
}

export const clearChecklistDailyCurrentErrors = () => dispatch => {
  dispatch({ type: CLEAR_CHECKLIST_DAILY_CURRENT_ERRORS_SUCCESS })
}


// WEBPACK FOOTER //
// ./src/actions/checklist.js